import request from '../../utils/request';

export const materialService = {
    getMaterialData: (data) => {
        return request({
            url: '/material',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    getMaterialDataV2: (data) => {
        return request({
            url: '/material?version=2',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    //修改DC
    updateMaterialDc: (data, id) => {
        return request({
            url: '/material/saveDc/' + id,
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    materialList: (data) => {
        return request({
            url: `/material/materialList`,
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    getMaterilDetail: (id) => {
        return request({
            url: `material/detail/` + id,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
        })
    },
    getDetailForPqcp: (eightBitCode) => {
        return request({
            url: `material/detailForPqcp`,
            method: 'GET',
            params:{
                eightBitCode: eightBitCode
            }
        })
    },
    saveMateril: (id, data) => {
        return request({
            url: `material/save/` + id,
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
}
